export default __webpack_public_path__ + "static/cust_house-36ace2f0a5ed4e257c3be7e4b5190025.webp";